import React from 'react';
import {
  Col, Divider, Flex, Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import CommentsList from './CommentsList';

const { Title } = Typography;

interface CommentsProps {
  expert: {
    bestFeedbackComments?: {
      comment: string
    } [];
  }
}

const Comments = function ({ expert }: CommentsProps) {
  const { t } = useTranslation();

  const { bestFeedbackComments } = expert;

  return !!bestFeedbackComments?.length && (
    <Flex wrap justify="center" gap="large">
      <Divider />
      <Col span={24}>
        <Title level={4}>{t('chat:::communityGuuruFeedbacks')}</Title>
      </Col>
      <Col span={24}>
        <CommentsList dataSource={bestFeedbackComments} />
      </Col>
    </Flex>
  );
};

export default Comments;
